import init from '../../helpers/init';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('submit', '.js-questionnaire-form', e => {
    e.preventDefault();

    const form = $(e.currentTarget);
    const answers: any = form.serializeArray().reduce(function (accum: any, current) {
      accum[current.name] = current.value;
      return accum;
    }, {});

    BX.ajax.runComponentAction('pwd:exhibition.register.questionnaire', 'saveAnswers', {
      mode: 'class',
      data: {
        answers
      },
    }).then((result: any) => {
      location.href = location.href.replace('ticket', 'services');
    })
      .catch((err: any) => console.log(err));
  });
});
